import * as React from 'react';
import Step from '../Step';
import { StepProperties, PrivateStepState, SharedStepState } from '../Step';
import BucketNameProvision from './BucketNameProvision';
import { RightArrowIcon } from '../../common/Icons';
import { NameRequirementManager } from '../../common/requirementManagers/NameRequirementManager';
import {
    UrlValidator,
    LettersNumbersHyphensValidator,
    MixedcaseStartEndValidator,
    StringLengthValidator
} from '../../../services/nameValidation';
import FlowManager from '../../common/FlowManager';

interface EndpointStepProperties extends StepProperties<EndpointSharedStepState> {
    regionRequired?: boolean;
    exampleUrl: string;
}

export interface EndpointSharedStepState extends SharedStepState, BucketNameProvision {
    endpointUrl: string;
    endpointRegion: string;
}

interface EndpointPrivateStepState extends PrivateStepState {}
interface EndpointStepState extends EndpointPrivateStepState, EndpointSharedStepState {}

class EndpointStepComponent extends Step<EndpointStepProperties, EndpointStepState, EndpointSharedStepState> {
    private urlRequirementManager: NameRequirementManager = new NameRequirementManager();
    private regionRequirementManager: NameRequirementManager = new NameRequirementManager();
    private flowManager: FlowManager;

    constructor(props: any) {
        super(props);

        this.handleUserInputChanged = this.handleUserInputChanged.bind(this);
        this.canContinue = this.canContinue.bind(this);

        this.flowManager = new FlowManager(this.canContinue, this.completeStep);
        this.flowManager.registerListeners();

        this.state = this.props.savedState;
    }

    componentWillMount() {
        this.setValidators();
    }

    render() {
        return (
            <div className="col-12 col-lg-6 col-xl-6 offset-lg-1 d-flex align-items-center input-step">
                <form>
                    <div className="float-label-control large row">
                        <input
                            spellCheck={false}
                            autoFocus={true}
                            value={this.state.endpointUrl}
                            type="text"
                            className="form-control col-12"
                            placeholder="Endpoint URL"
                            name="ep-url"
                            id="ep-url"
                            onChange={this.handleUserInputChanged}
                        />
                        <label htmlFor="ep-url">Endpoint URL</label>
                        <div className="under__input">
                            <p className="left col minitext">{this.urlRequirementManager.getRequirements(this.state.endpointUrl)}</p>
                            <p className="right col minitext">Amazon S3 compatible endpoint<br />Example: {this.props.exampleUrl}</p>
                        </div>
                    </div>
                    <div className="float-label-control large row">
                        <input
                            type="text"
                            value={this.state.endpointRegion}
                            className="form-control col-12"
                            placeholder="Region name"
                            name="ep-region"
                            id="ep-region"
                            onChange={this.handleUserInputChanged}
                        />
                        <label htmlFor="ep-region">Region name {!this.props.regionRequired ? '(optional)' : ''}</label>
                    </div>
                    {this.regionRequirementManager.getRequirements(this.state.endpointRegion)}
                    <div>
                        <div className="checkbox">
                            <input
                                type="checkbox"
                                name="bucketname"
                                id="bucketname"
                                checked={this.state.ownBucketNameProvided}
                                onChange={this.handleUserInputChanged}
                            />
                            <label htmlFor="bucketname">Configure advanced settings</label>
                        </div>
                    </div>
                    <button type="button" disabled={!this.canContinue()} className="btn step-btn float-left" onClick={this.completeStep}>
                        <span>Next</span>
                        <RightArrowIcon width="13px" height="13px" />
                    </button>
                </form>
            </div>
        );
    }

    componentWillUnmount() {
        this.flowManager.unregisterListeners();
    }

    protected getSharedStepState(): EndpointSharedStepState {
        return {
            endpointUrl: this.state.endpointUrl,
            endpointRegion: this.state.endpointRegion,
            ownBucketNameProvided: this.state.ownBucketNameProvided
        };
    }

    private canContinue(): boolean {
        return this.urlRequirementManager.requirementsAreMet() && this.regionRequirementManager.requirementsAreMet();
    }

    private handleUserInputChanged(e: any): void {
        if (e.target.type === 'checkbox') {
            this.setState({ ownBucketNameProvided: e.target.checked });
        } else {
            if (e.target.name === 'ep-url') {
                this.setState({ endpointUrl: e.target.value.trim() });
            } else if (e.target.name === 'ep-region') {
                this.setState({ endpointRegion: e.target.value.trim().trim() });
            }
        }
    }

    private setValidators(): void {
        this.urlRequirementManager.setValidators([
            new UrlValidator('Endpoint URL must be a valid url')
        ]);
        this.regionRequirementManager.setValidators([
            new LettersNumbersHyphensValidator('Region must contain only letters, numbers or hyphens', !this.props.regionRequired),
            new MixedcaseStartEndValidator('Region must start and end with a letter or number', !this.props.regionRequired),
            new StringLengthValidator(2, null, 'Region must be at least 2 characters long', !this.props.regionRequired)
        ]);
    }
}

export default EndpointStepComponent;



// WEBPACK FOOTER //
// ./src/webportal/components/wizard/components/EndpointStep.tsx